module.exports = "<!-- htmlcs-disable -->\n<div class=\"{{styles.reportContainer}}\" >\n    <span on-click=\"setReport\">举报/反馈</span>\n</div>";